import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';
import ContactImg from "src/assets/images/home/contact.webp";

import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';
import useWindowWidth from 'src/hooks/useWindowWidth';
import CustomButton from 'src/components/customButton/CustomButton';
import { isRTL } from 'src/utils/global';

const ContactSection = () => {
    const { t, i18n } = useTranslation("home");
    const width = useWindowWidth();

    return (
        <section className={`${styles.con} ${isRTL() && styles.rtl}`}>
            <div className='container'>
                <div className="row">
                    <div className='col-lg-6 col-12 '>
                        <div className={styles.item__img}>
                            <img src={ContactImg} alt={t("contact.image_alt")} />
                        </div>
                    </div>
                    <div className='col-lg-6 col-12 m-auto'>
                        <div className={styles.item__content}>
                            <div className={styles.subTitle}>
                                {t("contact.sub_title")}
                            </div>
                            <h3>{t("contact.title")}</h3>
                            <p className='global-p'>{t("contact.description")}</p>
                            <CustomButton
                                text={
                                    <>
                                        {t("contact.btn")}
                                        {width > 991 ? i18n.language.includes("ar") ? (
                                            <FaArrowLeft color="#fff" />
                                        ) : (
                                            <FaArrowRight color="#fff" />
                                        ) : null}
                                    </>
                                }
                                theme="primary"
                                to='https://wa.me/218923787927'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
